import { ActionTree } from 'vuex'
import { PartnerService } from '@/services/PartnerService'

import types from './types'
const { GENERIC_MUTATION } = types

const setAccountInfo = ({ commit }: any, value: any) =>
  commit(GENERIC_MUTATION, {
    property: 'accountInfo',
    value
  })

const setUserInfo = ({ commit }: any, value: any) =>
  commit(GENERIC_MUTATION, {
    property: 'userInfo',
    value
  })

const setCurrentInConfiguration = ({ commit }: any, value: any) =>
  commit(GENERIC_MUTATION, {
    property: 'currentInConfiguration',
    value
  })

const setPartnerCustomers = ({ commit }: any, customers: any) => {
    commit(GENERIC_MUTATION, {
      property: 'partnerCustomers',
      value: customers
    })
}

const setLoadingPartnerCustomers = ({ commit }: any, value: boolean) => {
    commit(GENERIC_MUTATION, {
      property: 'isLoadingPartnerCustomers',
      value
    })
  }

const fetchPartnerCustomers = async (
    { dispatch }: any,
    { partnerHash, pageNumber, pageSize, order, filter }: any
    ) => {
      dispatch('setLoadingPartnerCustomers', true)
      try {
        const customers = (await PartnerService.getInstance().getPartnerCustomers(partnerHash, pageNumber, pageSize, order, filter)) as any
        dispatch('setPartnerCustomers', customers)
      } catch (err) { } finally {
        dispatch('setLoadingPartnerCustomers', false)
      }
  }

export default <ActionTree<any, any>>{
  setAccountInfo,
  setUserInfo,
  setCurrentInConfiguration,
  setPartnerCustomers,
  setLoadingPartnerCustomers,
  fetchPartnerCustomers
}
